import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {JobEnteredPanel} from 'src/jobs/job-entry/job-entered-panel'

export const Route = createFileRoute('/_app/jobs/create/done/$jobId')({
    validateSearch: (search: Record<string, unknown>): {added?: 1} =>
        search['added'] === 1 || search['added'] === '1' ? {added: 1} : {},
    component: JobEnteredRoute,
})

function JobEnteredRoute() {
    const {jobId} = Route.useParams()
    const {added} = Route.useSearch()
    return (
        <Container size="sm" py="xl">
            <JobEnteredPanel jobId={jobId} addedToOrder={added === 1} />
        </Container>
    )
}
